<template>
  <div
    class="d-flex align-items-center justify-content-between w-100 flex-wrap"
  >
    <div class="">
      <p>各種フィルター</p>
      <div class="d-flex align-items-center">
        <div class="d-flex flex-column me-2">
          <p class="mb-2">組織</p>
          <Dropdown
            v-model="selectedOrganizationId"
            :options="organizations"
            option-value="id"
            option-label="name"
          />
        </div>

        <div class="d-flex flex-column me-2">
          <p class="mb-2">公開範囲</p>
          <Dropdown
            v-model="selectedForMembers"
            :options="
              newsFilterOptions.filter(
                (o) => !viewmode || o.value !== 'nonpublished'
              )
            "
            option-value="value"
            option-label="label"
          />
        </div>

        <div class="d-flex flex-column">
          <p class="mb-2">種別</p>
          <Dropdown
            v-model="selectedNewsLabel"
            :options="['all', ...newsLabels]"
            :option-label="(v) => (v === 'all' ? '全て' : labelTranslater(v))"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { labelTranslater } from "/@/modules/news";
import { NewsClient, OrganizationClient, newsLabels } from "/@/types";
import { useNews } from "/@/vue/composables";
import Dropdown from "primevue/dropdown";

const selectedOrganizationId = defineModel<number>("selectedOrganizationId");
const selectedForMembers = defineModel<string>("selectedForMembers");
const selectedNewsLabel = defineModel<NewsClient["label"] | "all" | null>(
  "selectedNewsLabel"
);

defineProps<{
  organizations: OrganizationClient[];
  viewmode?: boolean;
}>();

const { newsFilterOptions } = useNews();
</script>

<style scoped lang="scss"></style>
